<template>
  <div class="act-liveness-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="top-bg"></div>
    <div class="liveness-tit">{{ $t('lang.Liveness.k008') }}</div>
    <div class="liveness-content">
      <div class="top-con">{{ $t('lang.Liveness.k009') }}</div>
      <div class="bottom-con">
        <p class="bottom-tit">{{ $t('lang.Liveness.k010') }}</p>
        <p class="bottom-txt">{{ $t('lang.Liveness.k011') }}</p>

        <p class="bottom-tit">{{ $t('lang.Liveness.k012') }}</p>
        <ul class="bottom-txt">
          <li>{{ $t('lang.Liveness.k013') }}</li>
          <li>
            {{ $t('lang.Liveness.k014') }}
            <i>{{ $t('lang.Liveness.k015') }}</i>
            {{ $t('lang.Liveness.k016') }}
          </li>
          <li>{{ $t('lang.Liveness.k017') }}</li>
          <li>{{ $t('lang.Liveness.k018') }}</li>
        </ul>

        <p class="bottom-tit">{{ $t('lang.Liveness.k019') }}</p>
        <p class="bottom-txt">{{ $t('lang.Liveness.k020') }}</p>

        <p class="bottom-tit">{{ $t('lang.Liveness.k021') }}</p>
        <p class="bottom-txt">
          <i>{{ $t('lang.Liveness.k022') }}</i>
          {{ $t('lang.Liveness.k023') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import { getAwsInfoApi } from '@/api/imee.js'

export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  methods: {},
  created() {}
}
</script>
<style lang="scss" scoped>
.act-liveness-root {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #a0f 0%, #7f00ff 100%);
  position: relative;

  .custom-nav-block {
    background-color: transparent;
  }

  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 375px;
    height: 150px;
    background: url(./images/bg-star.png) center center / 100% 100% no-repeat;
  }

  .liveness-tit {
    color: #fff;
    text-align: center;
    font-family: 'BarlowSemiCondensed-Regular';
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.07px;
    margin-top: 4px;
  }

  .liveness-content {
    width: 343px;
    min-height: 500px;
    margin: 0 auto;
    background: linear-gradient(180deg, #a0f 0%, #7f00ff 100%);
    margin-top: 24px;

    .top-con {
      display: flex;
      padding: 16px 12px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 8px 8px 0 0;
      background: rgba(0, 0, 0, 0.3);

      color: #fff;
      font-family: 'BarlowSemiCondensed-Regular';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.07px;
    }
    .bottom-con {
      display: flex;
      padding: 24px 20px;
      flex-direction: column;
      align-items: flex-start;
      gap: 13px;
      align-self: stretch;

      border-radius: 0 0 8px 8px;
      background: rgba(0, 0, 0, 0.2);

      .bottom-tit {
        color: #fff;
        font-family: 'BarlowSemiCondensed-Regular';
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.07px;
      }

      .bottom-txt {
        color: #fff;
        font-family: 'BarlowSemiCondensed-Regular';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0.07px;
        i {
          font-weight: 700;
        }
      }
      ul.bottom-txt {
        margin-left: 20px;
        li {
          list-style-type: disc;
          line-height: 18px;
          i {
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
